/**
 * Permisos del sistema.
 */
export enum PERMISOS {
	ADMINISTRADOR = "Administrador",
	USUARIO_EMPRESA = "UsuarioEmpresa",
	ADMINISTRADOR_EMPRESA = "AdministradorEmpresa",
}
